import { auth } from '@/store/authStore';
import { getMarketingSiteHref } from '@/utils/publicSite';

export const clearApplicationAuth = () => {
  auth.clearAuth();
};

export const redirectToMarketingSite = (replace = false) => {
  const destination = getMarketingSiteHref();
  if (replace) {
    window.location.replace(destination);
    return;
  }

  window.location.assign(destination);
};

export const logoutToMarketingSite = (replace = false) => {
  clearApplicationAuth();
  redirectToMarketingSite(replace);
};

export const handleExpiredAdminSession = () => {
  const user = auth.getUser();
  if (!user.isAuthenticated || user.role === 'parent') {
    return false;
  }

  logoutToMarketingSite(true);
  return true;
};
